export const CestaProductRevisionMoto = 'revision_moto'
export const CestaProductRevisionCoche = 'revision'
